module.exports = __webpack_public_path__ + "static/media/teacher24.e0e07fc0.png";